export default "__VITE_ASSET__BexZyl_5__"